import './HeroImg.css';
import React from 'react'
import IntroImage from '../assets/andras-vas-Bd7gNnWJBkU-unsplash.jpg'
import { Link } from 'react-router-dom'
const HeroImg = () => {
  return (
    <div className='hero'>
      <div className='mask'>
       <img className='Image-main' src={IntroImage} alt="IntroImage"/>
      </div>
      <div className='content'>
        <p>HI, I'M A FREELANCER </p>
        <h1>Web Developer.</h1>
        <div>
          <Link to='/project' className="btn">Projects</Link>
          <Link to='/contact' className="btn btn-light">Contact</Link>
        </div>
      </div>
    </div>
  )
}

export default HeroImg
